/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { of } from "rxjs";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { ActionGridField } from "@src/app/shared/action/action-grid-field";

export type ActionType = 'future'|'past'

export class AddActionFormAction implements IFormAction {
    name = $localize`Add Action`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'format_list_bulleted_add';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText: string;

    //constructor(private addFn: () => Observable<AbstractObject>, private linksTo: LinksTo) { }
    constructor(private actionGrid: ActionGridField, private actionType: ActionType = 'future') { 
        if (this.actionType === 'past') {
            this.icon = 'check_circle';
            this.name = $localize `Log Completed Action`;
            this.tipText = $localize `Log an action that has already been completed against this unit`
        } else {
            this.icon = 'alarm';
            this.name = $localize `Add Reminder`
            this.tipText = $localize `Log an action as a reminder to do something in the future related to this unit`
        }
    }

    action() { //item: AbstractObject, config: FormConfig
        this.actionGrid.upsertAction(null, this.actionType).subscribe(action => {
            if (action) {
                this.actionGrid.control.addRow(action, true, true);
            }
        });
        return of(null);
        /*return this.addFn().pipe(
            mergeMap((action) => {
                const id = this.linksTo === 'Person' ? 'personId' : 'unitId';
                return of(action).pipe(() => config.service.getOne(id, null));
            }));
            */
    }
    //  setup(serviceRequest: ServiceRequest) {
    setup() {
        this.show = true;
    }
}
